import gql from "graphql-tag";

export const UPDATE_COSTUME_FEATURE_NOTE = gql`
  mutation UpdateCostumeFeatureNote(
    $updateCostumeFeatureNoteId: ID!
    $note: String!
  ) {
    updateCostumeFeatureNote(
      id: $updateCostumeFeatureNoteId
      note: $note
    ) {
      basePrice
    }
  }
`;
